import React from "react";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";

import ErrorPage from "./ErrorPage";

export default function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  let errorUrl = "";
  let trusted = false;

  try {
    errorUrl = error?.url || error?.response?.url || error?.data?.url || "";

    const allowedSources = ["healthnsyncinfra.net", "healthnsync.com", "netproapp.com"];

    const isTrustedSource = (url) => {
      if (!url) {
        return false;
      }
      try {
        const hostname = new URL(url).hostname;
        return allowedSources.some((domain) => hostname.endsWith(domain));
      } catch {
        return false;
      }
    };

    trusted = isTrustedSource(errorUrl);

    if (trusted) {
      console.error(error?.message || "No route error message");
      console.error("Error object:", error);
      console.error("Request URL:", errorUrl);
    }
  } catch (err) {
    console.error("ErrorBoundary caught an exception:", err);
  }

  try {
    const isRouteError = isRouteErrorResponse(undefined);

    if (isRouteError) {
      if (error?.status === 401 && trusted) {
        navigate("/landing");
      }
    }
  } catch (err) {
    console.error("Error while handling route error:", err);
  }

  return <ErrorPage />;
}
